<template>
  <div>
    <b-table
      :items="rows"
      :fields="fields"
      :busy="loading"
      small
      striped
      responsive
      show-empty
      empty-text="Событий нет"
    >
      <template #cell(createdAt)="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template #cell(level)="{ item }">
        <b-badge :variant="levelVariants[item.level] || 'light'">
          {{ item.level }}
        </b-badge>
      </template>
      <template #cell(event)="{ item }">
        <code>{{ item.event }}</code>
        <small
          v-if="item.subscriber"
          class="d-block text-muted"
        >{{ item.subscriber }}</small>
      </template>
      <template #cell(details)="{ item, toggleDetails, detailsShowing }">
        <b-button
          v-if="hasDetails(item)"
          size="sm"
          variant="flat-secondary"
          @click="toggleDetails"
        >
          {{ detailsShowing ? 'Скрыть' : 'Подробнее' }}
        </b-button>
      </template>
      <template #row-details="{ item }">
        <pre class="mb-0 small">{{ details(item) }}</pre>
      </template>
    </b-table>

    <b-pagination
      v-if="count > perPage"
      :value="page"
      :total-rows="count"
      :per-page="perPage"
      align="center"
      class="mt-1"
      @change="$emit('page', $event)"
    />
  </div>
</template>

<script>
import {
  BBadge, BButton, BPagination, BTable,
} from 'bootstrap-vue'
import { EVENT_LEVEL_VARIANTS, formatDate } from '../payment-labels'

export default {
  name: 'PaymentEventsTable',
  components: {
    BBadge, BButton, BPagination, BTable,
  },
  props: {
    rows: { type: Array, default: () => [] },
    count: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    perPage: { type: Number, default: 50 },
    loading: { type: Boolean, default: false },
    // a payment's own journal does not need to repeat which payment it is
    showPayment: { type: Boolean, default: false },
  },
  data() {
    return { levelVariants: EVENT_LEVEL_VARIANTS }
  },
  computed: {
    fields() {
      return [
        { key: 'createdAt', label: 'Время' },
        { key: 'level', label: 'Уровень' },
        { key: 'event', label: 'Событие' },
        { key: 'source', label: 'Источник' },
        { key: 'status', label: 'Статус' },
        { key: 'outcome', label: 'Итог' },
        ...(this.showPayment ? [{ key: 'externalOrderId', label: 'Платёж ЮKassa' }] : []),
        { key: 'error', label: 'Ошибка' },
        { key: 'details', label: '' },
      ]
    },
  },
  methods: {
    formatDate,
    hasDetails(item) {
      return Boolean(item.context || item.payload)
    },
    details(item) {
      return JSON.stringify({ context: item.context, payload: item.payload }, null, 2)
    },
  },
}
</script>
